import script from "./acompanhamento-senhas.vue?vue&type=script&setup=true&lang=js"
export * from "./acompanhamento-senhas.vue?vue&type=script&setup=true&lang=js"

import "./acompanhamento-senhas.vue?vue&type=style&index=0&id=088a6b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088a6b04"]])

export default __exports__